import { SxProps, Theme } from "@mui/material";
import colorsConstants from "src/app/constants/colors.constants";

const styles = {
  parent: {
    backgroundColor: colorsConstants.mainContentBackgroundColor,
    flex: 1,
    display: "flex",
    height: "100vh",
  },
  drawerAwareContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: "24px",
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    width: "90%",
    positionAnchor: "revert",
  },
  titleText: {
    color: colorsConstants.primaryText,
    fontSize: 24,
    textAlign: "center",
    flex: 1,
    marginLeft: "24px",
  },
  tabsContainer: {
    borderRadius: "10px",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    backgroundColor: "transparent",
    boxShadow: "none",
  },
  selectedTab: {
    p: { xs: 2, sm: 3 },
  },
  selectedTabContent: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    height: "100%",
    boxShadow: "none",
  },
  emergencyTabContent: {
    backgroundColor: colorsConstants.emergencyRequestCardBackground,
    border: "2px solid rgb(253, 184, 184)",
  },
  selectedTabText: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
    mb: 2,
  },
  searchBox: {
    mb: 2,
    backgroundColor: "transparent",
  },
  searchingLoader: {
    display: "flex",
    justifyContent: "center",
    py: 4,
  },
  usersListParent: {
    p: 0,
  },
  usersListItem: {
    borderRadius: 2,
    mb: 1,
  },
  noUsersText: {
    color: colorsConstants.primaryText,
    opacity: 0.7,
  },
  calendarContainer: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    minHeight: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxShadow: "none",
  },
  calendarTitleText: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
    mb: 2,
  },
  subTitleText: {
    color: colorsConstants.primaryText,
    opacity: 0.7,
    mt: 4,
  },
  timeslotsContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: 1,
    mb: 2,
  },
  requesterNameContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 1,
    mb: 1,
  },
  requesterNameText: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
    mb: 0.5,
  },
  requesterDate: {
    color: colorsConstants.primaryText,
    mb: 0.5,
  },
  requesterDescription: {
    color: colorsConstants.primaryText,
    mb: 2,
  },
  requestActionsContainer: {
    display: "flex",
    gap: 1,
    flexWrap: "wrap",
  },
  emergencyMeetingButton: {
    mt: 1,
    backgroundColor: colorsConstants.error,
  },
  emergencyRequestDescriptionTextField: {
    mt: 2,
    mb: 2,
    backgroundColor: "transparent",
  },
  emergencyRequestModalActionsContainer: {
    display: "flex",
    flex: 1,
    justifyContent: "space-evenly",
    mb: 1.5,
  },
  modalCancelButton: { color: colorsConstants.error },
  selectorContainer: {
    width: "100%",
  },
  selectorPaper: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
